import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import { api, badge, clock, localText, whereText, icsHref, go, cover } from './util';

/** /events/{id}: cover, title, organiser, when and where, tickets, and about, laid out like an invitation. */
export default class EventView extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.id = Number(m.route.param('id'));
    this.event = null;
    this.missing = false;
    const pre = app.data && app.data.vouchaEvent;
    if (pre && Number(pre.id) === this.id) {
      this.event = pre;
      delete app.data.vouchaEvent;
      app.setTitle(pre.title);
    }
    app.request({
      method: 'GET',
      url: api('/' + this.id),
      errorHandler: () => {}
    }).then(r => {
      this.event = r.event;
      this.canModerate = r.canModerate;
      app.setTitle(r.event.title);
    }).catch(() => {
      if (!this.event) this.missing = true;
    }).then(() => m.redraw());
  }

  /**
   * Take the event down: the first tap asks, the second does it. No browser confirm() box: a browser told to stop
   * showing dialogs answers "no" silently, which left the button doing nothing. Errors show under the button.
   */
  remove() {
    if (this.removing) return;
    if (!this.confirming) {
      this.confirming = true;
      this.removeError = null;
      clearTimeout(this.confirmTimer);
      this.confirmTimer = setTimeout(() => {
        this.confirming = false;
        m.redraw();
      }, 6000);
      return;
    }
    clearTimeout(this.confirmTimer);
    this.removing = true;
    app.request({
      method: 'DELETE',
      url: api('/' + this.id),
      errorHandler: () => {}
    }).then(() => {
      // a full load, so the events list doesn't show it from memory
      window.location.assign(app.forum.attribute('baseUrl') + '/events');
    }).catch(err => {
      this.removing = false;
      this.confirming = false;
      const msg = err && err.response && err.response.message;
      this.removeError = err && err.status === 403 ? 'You can only take down your own events.' : msg || 'Could not take the event down. Try again.';
      m.redraw();
    });
  }
  onremove(vnode) {
    super.onremove(vnode);
    clearTimeout(this.confirmTimer);
  }
  copy() {
    const url = window.location.origin + '/events/' + this.id;
    if (navigator.share && /Mobi/i.test(navigator.userAgent)) navigator.share({
      title: this.event.title,
      url
    }).catch(() => {});else if (navigator.clipboard) navigator.clipboard.writeText(url).then(() => app.alerts.show({
      type: 'success'
    }, 'Link copied.'));
  }
  dateText(e) {
    const opts = {
      weekday: 'long',
      month: 'long',
      day: 'numeric'
    };
    try {
      return new Intl.DateTimeFormat('en-US', Object.assign({
        timeZone: e.timezone
      }, opts)).format(new Date(e.startsAt));
    } catch (err) {
      return new Intl.DateTimeFormat('en-US', opts).format(new Date(e.startsAt));
    }
  }
  view() {
    if (this.missing) {
      return m("div", {
        className: "VEvt VEvt-empty"
      }, m("p", null, "This event isn't available. It may have ended, or it is still waiting for approval."), m("a", {
        href: "/events",
        onclick: go('/events')
      }, "See upcoming events \u2192"));
    }
    const e = this.event;
    if (!e) return m(LoadingIndicator, null);
    const b = badge(e);
    const mine = app.session.user && e.organiser && app.session.user.username() === e.organiser.username;
    const mapUrl = e.format !== 'online' && (e.address || e.venue) ? 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent([e.venue, e.address, e.placeName].filter(Boolean).join(', ')) : null;
    const local = localText(e);
    const placeUrl = e.placeSlug ? app.route('tag', {
      tags: e.placeSlug
    }) : null;
    return m("article", {
      className: "VEvt VEvtD"
    }, e.status && e.status !== 'approved' ? m("p", {
      className: 'VEvt-status is-' + e.status
    }, e.status === 'pending' ? 'Waiting for approval: only you and moderators can see this.' : 'This event was not approved.') : null, m("div", {
      className: "VEvtD-bar"
    }, m("a", {
      href: "/events",
      onclick: go('/events')
    }, "\u2190 Events"), m("span", null, m(Button, {
      className: "Button",
      icon: "far fa-copy",
      onclick: () => this.copy()
    }, "Copy link"), m("a", {
      className: "Button",
      href: icsHref(e),
      download: 'voucha-event-' + e.id + '.ics'
    }, m("i", {
      className: "far fa-calendar-plus",
      "aria-hidden": "true"
    }), " Add to calendar"))), m("div", {
      className: "VEvtD-layout"
    }, m("div", {
      className: "VEvtD-side"
    }, cover(e, 'VEvtD-cover')), m("div", {
      className: "VEvtD-main"
    }, placeUrl ? m("a", {
      className: "VEvtD-place",
      href: placeUrl,
      onclick: go(placeUrl)
    }, m("i", {
      className: "fas fa-location-dot",
      "aria-hidden": "true"
    }), " In ", m("b", null, e.placeName), " \u203A") : e.format === 'online' ? m("span", {
      className: "VEvtD-place"
    }, m("i", {
      className: "fas fa-video",
      "aria-hidden": "true"
    }), " ", m("b", null, "Online")) : null, m("h1", null, e.title), e.organiser ? m("a", {
      className: "VEvtD-by",
      href: '/u/' + e.organiser.username,
      onclick: go('/u/' + e.organiser.username)
    }, "Hosted by ", e.organiser.name, " \u203A") : null, m("div", {
      className: "VEvtD-facts"
    }, m("div", {
      className: "VEvtD-fact"
    }, m("span", {
      className: "VEvtD-cal"
    }, m("small", null, b.month), m("b", null, b.date)), m("span", null, m("strong", null, this.dateText(e)), m("small", null, clock(e.startsAt, e.timezone), e.endsAt ? ' – ' + clock(e.endsAt, e.timezone) : '', local ? ' · ' + local : ''))), m("div", {
      className: "VEvtD-fact"
    }, m("span", {
      className: "VEvtD-icon"
    }, m("i", {
      className: 'fas ' + (e.format === 'online' ? 'fa-video' : 'fa-location-dot'),
      "aria-hidden": "true"
    })), m("span", null, mapUrl ? m("a", {
      href: mapUrl,
      target: "_blank",
      rel: "noopener"
    }, m("strong", null, e.venue || whereText(e), " \u2197")) : m("strong", null, e.format === 'online' ? 'Online' : e.venue || whereText(e)), m("small", null, [e.address, e.placeName, e.format === 'hybrid' ? 'and online' : null].filter(Boolean).join(', '))))), m("section", {
      className: "VEvtD-card"
    }, m("h3", null, e.ticketUrl ? 'Get tickets' : 'Registration'), m("div", {
      className: "VEvtD-cardBody"
    }, m("small", null, "Price"), m("p", {
      className: "VEvtD-price"
    }, e.price || 'Free'), m("div", {
      className: "VEvtD-cardButtons"
    }, e.ticketUrl ? m("a", {
      className: "Button Button--primary",
      href: e.ticketUrl,
      target: "_blank",
      rel: "noopener nofollow ugc"
    }, e.price && !/^free$/i.test(e.price) ? 'Get tickets' : 'Register', " \u2197") : m("a", {
      className: "Button Button--primary",
      href: icsHref(e),
      download: 'voucha-event-' + e.id + '.ics'
    }, "Add to my calendar"), e.onlineUrl ? m("a", {
      className: "Button",
      href: e.onlineUrl,
      target: "_blank",
      rel: "noopener nofollow ugc"
    }, "Join online \u2197") : null))), m("section", {
      className: "VEvtD-about"
    }, m("h3", null, "About event"), e.description.split(/\n{2,}/).map(para => m("p", null, para.split('\n').map((line, i) => [i ? m("br", null) : null, line])))), m("p", {
      className: "VEvt-note"
    }, "Posted by a member and checked by Voucha's moderators. Check details with the host before you travel or pay."), mine || this.canModerate ? m("div", {
      className: "VEvt-removeWrap"
    }, m(Button, {
      className: "Button Button--link VEvt-remove",
      icon: "fas fa-trash",
      loading: this.removing,
      onclick: () => this.remove()
    }, this.confirming ? 'Tap again to take it down for good' : 'Take this event down'), this.removeError ? m("p", {
      className: "VEvt-removeError"
    }, this.removeError) : null) : null)));
  }
}
flarum.reg.add('voucha-community', 'forum/events/EventView', EventView);